export default "__VITE_ASSET__opMA0mIx__"